import { Grid } from "@mui/material";

export default function DefaultContainer({children, style}){
    return (<Grid 
    style={{...style, padding:'5vh 8vw 0 8vw', display:'flex', flexDirection:'column'}}
      container>
          {children}
      </Grid>)
}